import { useOktaAuth } from '@okta/okta-react';
import React from 'react';
import { setSessionExpired } from '../redux/slices/userSlice';
import { useAppDispatch } from '../hooks/useRedux';

type Props = {
  children: React.ReactNode;
};

const AuthGuard = ({ children }: Props) => {
  // use hooks
  const { authState, oktaAuth } = useOktaAuth();
  const dispatch = useAppDispatch();

  // handling session expired
  oktaAuth.tokenManager.on('expired', (key) => {
    console.log('handling session expire');
    oktaAuth.tokenManager.renew('accessToken');
    // dispatch(setSessionExpired(true));
  });

  oktaAuth.tokenManager.on('renewed', function (key, newToken, oldToken) {
    if ('accessToken' in newToken) {
      console.log('handling new token');
      oktaAuth.tokenManager.setTokens({ accessToken: newToken });
    } else {
      console.log('handling sign in with redirect');
      oktaAuth.signInWithRedirect({ originalUri: window.location.href });
    }
  });

  if (authState === null || authState === undefined) {
    return <div> Loading.... </div>;
  }
  if (!authState.isAuthenticated) {
    oktaAuth.signInWithRedirect({ originalUri: window.location.href });
    return <div> Loading.... </div>;
  }
  console.log(window.history, 'window history');
  return <div>{children}</div>;
};

export default AuthGuard;
